import React, { useEffect, useState } from 'react';
import { Box, Typography, Fade } from '@mui/material';

const CenteredToast = ({ message = "操作成功", open = true, onClose }) => {
  const [visible, setVisible] = useState(open);

  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        setVisible(false);
        if (onClose) onClose();
      }, 3000); // 3 秒后关闭
      return () => clearTimeout(timer);
    }
  }, [visible, onClose]);

  return (
    <Fade in={visible} timeout={500}>
      <Box
        sx={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'rgba(0,0,0,0.7)',
          color: '#fff',
          px: 3,
          py: 2,
          borderRadius: 2,
          zIndex: 1500,
          backdropFilter: 'blur(4px)',
        }}
      >
        <Typography>{message}</Typography>
      </Box>
    </Fade>
  );
};

export default CenteredToast;
